import React, {useEffect} from 'react';
import {connect} from 'react-redux';
import {resetBlock} from '../StandAlonePurchaseSaleSlice';
import {clearStateHistoryAction} from '../../../../utilities/stateHistory/stateHistorySlice';
import OrderSuccess from '../OrderSuccess/OrderSuccess';

const SuccessPage = (props) => {
  useEffect(() => {
    window.scrollTo(0, 0);
    return () => {
      props.resetBlock();
      props.clearStateHistoryAction();
    };
  }, []);

  return (
    <div className='slideAnimation'>
      <div className='sale-page-content' id='order-number'>
        <OrderSuccess fullAddress={props.fullAddress} selectedDeliverySlot={props.selectedDeliverySlot} />
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    fullAddress: state.standAlonePurchaseSaleBlock?.tvProducts.filter((prd) => prd.chosenSubscription === true)[0].fullAddress ?? '',
    selectedDeliverySlot: state.standAlonePurchaseSaleBlock?.selectedDeliverySlot,
  };
};

const mapDispatchToProps = {resetBlock, clearStateHistoryAction};

export default connect(mapStateToProps, mapDispatchToProps)(SuccessPage);
